import { IA_KEY } from 'helpers/ia-logic';

import SkuOrderDashboard from './SkuOrderDashboard';
import { watchActions } from './SkuOrders.saga';

export default [
  {
    path: '/orders/:venueId',
    component: SkuOrderDashboard,
    iaKey: IA_KEY.SKU_ORDERS,
    isFixedPage: true,
    pathSagas: [watchActions],
  },
];
